import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { api } from "@/api"
interface CollaboratorBills {
    id: number
    title: string
    most_recent_comment: string | null
    current_status: number
    current_status_date: string
}

const fetchCollaboratorAssignedBills = async (): Promise<CollaboratorBills[] | { forbidden: true }> => {
    const response = await api.get("/api/collaboratorbill/get_assigned_bills/", { throwOnNotOk: false })
    if (!response.ok) {
        if (response.status === 403) {
            return { forbidden: true }
        }
    }
    return response?.json?.()
}

export const useCollaboratorAssignedBills = (enabled: boolean) =>
    useQuery({
        enabled: enabled,
        queryKey: ["fetchCollaboratorAssignedBills"],
        queryFn: fetchCollaboratorAssignedBills,
        staleTime: Infinity,
    })

const fetchCollaboratorBill = async (
    bill_id: string,
): Promise<QuorumModel["CollaboratorBill"] | { forbidden: true }> => {
    const response = await api.get(`/api/collaboratorbill/${bill_id}/`, { throwOnNotOk: false })
    if (!response.ok) {
        if (response.status === 403) {
            return { forbidden: true }
        }
    }
    const data = await response.json()
    return data
}

export const useCollaboratorBill = (bill_id: string, enabled: boolean) =>
    useQuery({
        enabled: enabled,
        queryKey: ["collaboratorBill", bill_id],
        queryFn: () => fetchCollaboratorBill(bill_id),
        staleTime: Infinity,
    })

export const useResetCollaboratorBill = () => {
    const queryClient = useQueryClient()
    return () => {
        queryClient.invalidateQueries({ queryKey: ["collaboratorBill"], exact: false })
        queryClient.invalidateQueries({ queryKey: ["fetchCollaboratorAssignedBills"], exact: false })
    }
}

export const useCreateCollaboratorComment = (billId, callback) => {
    const createComment = async (text: string) => {
        const body = {
            user_id: Userdata.id,
            comment_type: DjangIO.app.models.QuorumDataType.bill.value,
            note_type: DjangIO.app.userdata.types.NoteType.comment.value,
            is_visible_to_partners: false,
            text: text,
            bills: [`/api/newbill/${billId}/`],
        }
        const result = await api.post("/api/note/", body, { throwOnNotOk: false })
        if (result.ok) {
            callback()
        }
        return result
    }
    return useMutation({
        mutationFn: (text: string) => {
            return createComment(text)
        },
    })
}
